import React, { useRef } from 'react';
import { Heading } from '@fiverr-private/typography';
import { mixpanel } from '@fiverr-private/obs';
import { useEnteredView, useBreakpoint, useIsClient } from '@fiverr-private/hooks';
import { Container } from '@fiverr-private/layout_components';
import { TipsData } from '../../types';
import { TipsCarousel } from './TipsCarousel';
import { TipsList } from './TipsList';

interface TipsProps {
  data: TipsData;
  subCategory: string;
}

export const Tips: React.FC<TipsProps> = ({ data, subCategory }) => {
  const observableRef = useRef<HTMLDivElement>(null);

  const isClient = useIsClient();

  const isMobile = useBreakpoint() === 'default';

  useEnteredView(observableRef, {
    threshold: 1,
    onEntered: () => {
      mixpanel.track('Subcategory Tips - component show', {
        'Sub Category Name': subCategory,
      });
    },
  });

  const userClicked = () => {
    mixpanel.track('Subcategory Tips - seller click', {
      'Sub Category Name': subCategory,
    });
  };

  const title = `${subCategory} tips from top-tier talent`;

  return (
    <Container
      borderTopWidth="sm"
      borderColor="grey_500"
      borderStyle="solid"
      as="section"
      width="100%"
      paddingY="12"
      ref={observableRef}
    >
      <Heading as="h4" marginBottom="6">
        {title}
      </Heading>

      {isMobile && isClient ? (
        <TipsCarousel key="mobile" userClicked={userClicked} tips={data} />
      ) : (
        <TipsList key="desktop" userClicked={userClicked} tips={data} />
      )}
    </Container>
  );
};

export type { TipsProps };
